import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import PsContext from "../../../context";
import {
  APP_TYPE,
  COLLEGE,
  baseUrl,
  brandLogo,
  brandLogoNew,
  brandLogoWide,
} from "../../../utils";
import { ServiceUrl } from "../../../utils/serviceUrl";
import newIcon from "../../../assets/images/new_gif.gif";

const AdmissionAlertModal = (props) => {
  const context = useContext(PsContext);
  const [dataList, setDataList] = useState([]);
  const [loader, setLoader] = useState(false);
  const autoOpenTried = React.useRef(false);

  useEffect(() => {
    if (context.settings.length > 0 && !autoOpenTried.current) {
      if (Number(context.settingValue("show_admission_model")) === 1) {
        loadData();
        autoOpenTried.current = true;
      }
    }
  }, [context.settings.length]);

  const loadData = () => {
    setLoader(true);
    let url = "";
    if (APP_TYPE === "SAAS") url = "?sadb=" + COLLEGE;
    axios.get(ServiceUrl.ADMISSION.ANNOUNCEMENTS + url).then((res) => {
      if (res["data"].status === "1") {
        setDataList(res["data"].data);
        if (res["data"].data.length > 0) {
          context.setShowAdmissionAlert(true);
        }
      }
      setLoader(false);
    });
  };

  const handleClose = () => {
    context.setShowAdmissionAlert(false);
  };

  const renderContent = () => {
    return dataList.map((item, index) => (
      <div
        key={index}
        className="modern-announcement-item border-bottom py-3 d-flex align-items-start gap-3"
      >
        <img
          src={newIcon}
          alt="New"
          style={{ marginTop: "2px" }}
          className="new-icon-badge"
        />
        <div
          className="fs-14 fw-500 text-dark flex-grow-1"
          dangerouslySetInnerHTML={{ __html: item.content_html }}
        />
      </div>
    ));
  };

  if (Number(context.settingValue("show_admission_model")) !== 1) return null;

  return (
    <Modal
      show={context.showAdmissionAlert}
      onHide={handleClose}
      centered
      size="lg"
      backdrop="static"
      className="admission-global-modal"
    >
      <div className="bg-white rounded-0 border-0 shadow-2xl overflow-hidden glass-modal-effect">
        <div className="p-4 text-white d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center gap-3">
            <div className="bg-white">
              <img
                src={brandLogoWide()}
                alt=""
                className="w-100"
                style={{ maxWidth: "700px" }}
              />
            </div>
          </div>
          <button
            className="btn btn-link text-white p-0 opacity-70 hover-opacity-100 transition-all font-bold"
            style={{
              fontWeight: "700",
              border: "none",
              background: "transparent",
            }}
            onClick={handleClose}
          >
            <i className="fa-solid fa-xmark fs-24 text-black"></i>
          </button>
        </div>

        <Modal.Body
          className="p-4"
          style={{ maxHeight: "350px", overflowY: "hidden" }}
        >
          <div className="ps-v-marquee-container" style={{ height: "350px" }}>
            <div
              className="ps-v-marquee-content"
              style={{ animationDuration: "40s" }}
            >
              {renderContent()}
            </div>
          </div>
        </Modal.Body>

        <div className="p-4 bg-light bg-opacity-50 border-top d-flex justify-content-center">
          <Button
            variant="dark"
            className="btn-pay-compact px-5 py-2 fs-11 tracking-widest rounded-0"
            onClick={handleClose}
          >
            I HAVE READ THE ANNOUNCEMENTS
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AdmissionAlertModal;
